import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/ideal-weight-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/ideal-weight-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/ideal-weight-calculator",
      title: m.iw_meta_title(),
      description: m.iw_meta_description(),
      toolName: m.iw_tool_name(),
      faqs: [
        { q: m.iw_faq_q1(), a: m.iw_faq_a1() },
        { q: m.iw_faq_q2(), a: m.iw_faq_a2() },
        { q: m.iw_faq_q3(), a: m.iw_faq_a3() },
        { q: m.iw_faq_q4(), a: m.iw_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
